module.exports = __webpack_public_path__ + "img/restRoom.c02e8d21.png";